import React, { useState, useContext, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CommonAccordion from "../../custom-components/CommonAccordion";
import {
  Box,
  Typography,
  TextField,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import CommonDownload from "../../custom-components/CommonDownload";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { ReactComponent as BusinessProcessGuideIcon } from "../../../images/businessProcessGuideIcon.svg";
import { ReactComponent as BPGIcon } from "../../../images/BPGIconGrey.svg";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import {
  MultipleUserStoriesContext,
  UserStoriesLoaderContext,
} from "../../main-pages/MultipleUserStoryPage";
import MultiAccordian from "../testcase-generation/MultiAccordian";
import {
  refinedUserstory,
  userStoryToUseCase,
  businessProcessGuide,
  exportUserStoryToJira,
} from "../../../services/webServices";
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import SelectionErrorPopUp from "../../popup-components/SelectionerrorPop";
import ConfirmationDialog from "../../popup-components/ExportConfirmationPopup";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";
import { ReactComponent as ExportIcon1 } from "../../../images/ExportIcon1.svg";
import { ReactComponent as ExportButton } from "../../../images/exportButton.svg";
import { ReactComponent as ExportIcon } from "../../../images/exportIcon.svg";
import ALMConnectionPage from "../../main-pages/input-pages/ALMConnection/ALMConnectionPage";

const MultipleRefinedUserStory = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { userStoryLoaderState, setUserStoryLoaderState } = useContext(
    UserStoriesLoaderContext
  );
  const {
    multipleUserStories,
    multipleRefinedUserStory,
    multipleUseCases,
    setMultipleUseCases,
  } = useContext(MultipleUserStoriesContext);

  const selectedRefinedUserStoriesFromContext = useContext(
    MultipleUserStoriesContext
  ).selectedRefinedUserStories;

  const [multipleRefinedUserStories, setMultipleRefinedUserStories] = useState(
    multipleRefinedUserStory
  );
  const [selectedRefinedUserStories, setSelectedRefinedUserStories] = useState(
    selectedRefinedUserStoriesFromContext
  );
  const [editingValue, setEditingValue] = useState({});
  const [businessProcessData, setBusinessProcessData] = useState(null);
  // const [openDownload, setOpenDownload]= useState(false);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [noneSelectionPopOpen, setNoneSelectionPopOpen] = useState(false);
  const [message, setMessage] = useState(null);

  const defaultMultipleRefinedUserStoriesExpanded =
    multipleRefinedUserStory.length > 0 && multipleUseCases.length === 0;
  const [noneRefinedUserStoriesSelected, setNoneRefinedUserStoriesSelected] =
    useState(false);
  const { setLoadingState } = useContext(LoadingModalContext);

  const [isEditing, setIsEditing] = useState(false);
  const handleDownloadClick = () => {
    //changes
    setDownloadOpen(true);
  };

  const handleCloseDownload = () => {
    setDownloadOpen(false);
  };
  const hasSelectedUserStories = useMemo(() => {
    return selectedRefinedUserStories.some((story) => !!story);
  }, [selectedRefinedUserStories]);

  // useEffect(() => {
  //   setMultipleRefinedUserStories([...multipleRefinedUserStory]);
  //   setSelectedRefinedUserStories([...selectedRefinedUserStoriesFromContext]);
  // }, [multipleRefinedUserStory, selectedRefinedUserStoriesFromContext]);

  useEffect(() => {
    navigate(location.pathname, {
      state: {
        ...location.state,
        multipleRefinedUserStory: multipleRefinedUserStories,
        selectedRefinedUserStories,
      },
      replace: true,
    });
  }, [multipleRefinedUserStories, selectedRefinedUserStories]);

  const activeRefinedUserStories = [];
  multipleRefinedUserStories.map((eachUserStory, index) => {
    if (!!eachUserStory) {
      activeRefinedUserStories.push({ [index]: eachUserStory });
    }
  });

  const summaries = useMemo(
    () =>
      multipleRefinedUserStories.map((eachUserStory) => {
        return eachUserStory?.Title || null;
      }),
    [multipleRefinedUserStories]
  );

  const refinedUserStoriesComponents = multipleRefinedUserStories.map(
    (eachUserStory, refinedUserStoryIndex) => {
      if (!eachUserStory) {
        return null;
      }

      return (
        <Box key={`eachUserStory_${refinedUserStoryIndex}`}>
          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{ fontSize: "14px" }}
          >
            Title
          </Typography>
          {isEditing === refinedUserStoryIndex ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                name="Title"
                value={editingValue["Title"]}
                onChange={(e) => handleEdittedValue(e, refinedUserStoryIndex)}
                sx={{ marginTop: 1, marginRight: 1 }}
                inputProps={{ style: { fontSize: "14px" } }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                "&:hover": { backgroundColor: "white" },
              }}
            >
              <Typography
                variant="body1"
                sx={{ marginBottom: 2, fontSize: "14px" }}
              >
                {eachUserStory["Title"]}
              </Typography>
            </Box>
          )}
          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{ fontSize: "14px" }}
          >
            Description
          </Typography>
          {isEditing === refinedUserStoryIndex ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                name="Description"
                value={editingValue["Description"]}
                onChange={(e) => handleEdittedValue(e, refinedUserStoryIndex)}
                sx={{ marginTop: 1, marginRight: 1 }}
                inputProps={{ style: { fontSize: "14px" } }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                "&:hover": { backgroundColor: "white" },
              }}
            >
              <Typography
                variant="body1"
                sx={{ marginBottom: 2, fontSize: "14px" }}
              >
                {eachUserStory["Description"].split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </Typography>
            </Box>
          )}
          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{ fontSize: "14px" }}
          >
            Acceptance Criteria
          </Typography>
          {isEditing === refinedUserStoryIndex ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                name="Acceptance Criteria"
                value={editingValue["Acceptance Criteria"]}
                onChange={(e) => handleEdittedValue(e, refinedUserStoryIndex)}
                sx={{ marginTop: 1, marginRight: 1 }}
                inputProps={{ style: { fontSize: "14px" } }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                "&:hover": { backgroundColor: "white" },
              }}
            >
              {/* <Typography variant="body1" sx={{ fontSize: "14px" }}> */}
              <Typography
                variant="body1"
                sx={{ marginBottom: 2, fontSize: "14px" }}
              >
                {eachUserStory["Acceptance Criteria"]
                  .split("\n")
                  .map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
              </Typography>
            </Box>
          )}
          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{ fontSize: "14px" }}
          >
            Additional Information
          </Typography>
          {isEditing === refinedUserStoryIndex ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                name="Additional Information"
                value={editingValue["Additional Information"]}
                onChange={(e) => handleEdittedValue(e, refinedUserStoryIndex)}
                sx={{ marginTop: 1, marginRight: 1 }}
                inputProps={{ style: { fontSize: "14px" } }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                "&:hover": { backgroundColor: "white" },
              }}
            >
              <Typography variant="body1" sx={{ fontSize: "14px" }}>
                {eachUserStory["Additional Information"]
                  .split("\n")
                  .map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
              </Typography>
            </Box>
          )}
        </Box>
      );
    }
  );

  const handleEdittedValue = (event) => {
    const updatedValue = {
      ...editingValue,
      [event.target.name]: event.target.value,
    };
    setEditingValue(updatedValue);
  };

  // const handleDownload=()=>{
  //   setOpenDownload(true);
  // }

  const handleMultiUseCases = async () => {
    const totalUseCases = selectedRefinedUserStories.length;
    const totalDurationMs = totalUseCases * 25000;

    const progressHandler = handleProgressBar({
      totalDurationMs,
      setLoadingState
    });

    try {
      progressHandler.start(
        totalUseCases === 1
          ? "Generating Use Case"
          : "Generating Use Case for User Story 1"
      );

      setUserStoryLoaderState("Use Case");
      setMultipleUseCases([]);
      setBusinessProcessData([]);
      const updatedUseCases = [];
      const updatedBusinessProcessGuide = [];

      for (const [
        index,
        eachUserStory,
      ] of selectedRefinedUserStories.entries()) {
        if (eachUserStory && Object.keys(eachUserStory).length > 0) {
          if (totalUseCases > 1) {
            progressHandler.updateMessage(
              `Generating Use Case for User Story ${index + 1}`
            );
          } else {
            progressHandler.updateMessage("Generating Use Case");
          }

          const requestData = { ...eachUserStory };
          const useCases = await userStoryToUseCase({ userStory: requestData });

          const formattedUseCase = {};
          Object.entries(useCases.data).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              formattedUseCase[key] = flattenArray(value);
            } else if (typeof value === "object" && !!value) {
              formattedUseCase[key] = flattenObject(value);
            } else {
              formattedUseCase[key] = value;
            }
          });

          updatedUseCases[index] = formattedUseCase;

          try {
            if (totalUseCases > 1) {
              progressHandler.updateMessage(
                `Generating Business Process Guide for Use Case ${index + 1}`
              );
            } else {
              progressHandler.updateMessage(
                "Generating Business Process Guide"
              );
            }
            const businessProcessGuideData = await businessProcessGuide(
              formattedUseCase
            );
            updatedBusinessProcessGuide[index] = businessProcessGuideData.data;
          } catch (handleError) {
            console.error(
              `Error in generating Business Process Guide for use case at index ${index}:`,
              handleError
            );
            updatedBusinessProcessGuide[index] = null;
          }
        } else {
          updatedUseCases[index] = null;
          updatedBusinessProcessGuide[index] = null;
        }
      }

      setMultipleUseCases(updatedUseCases);
      setBusinessProcessData(updatedBusinessProcessGuide);

      await progressHandler.finishAndClose();

      navigate("/dashboard/multi-userstory/output/multiBusinessProcessGuide", {
        state: {
          ...location.state,
          multipleRefinedUserStories,
          selectedRefinedUserStories,
          multipleUseCases: updatedUseCases,
          businessProcessData: updatedBusinessProcessGuide,
        },
      });
    } catch (error) {
      console.error("Error handling multi-use cases:", error);
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      setUserStoryLoaderState(null);
      if (progressHandler) {
        progressHandler.stop();
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  const createWordData = (multipleRefinedUserStoriesData) => {
    const wordData = [];
    multipleRefinedUserStoriesData.map((eachUserStory) => {
      if (!!eachUserStory) {
        wordData.push({
          heading: "Refined User Story",
          type: "subParagraphs",
          data: eachUserStory,
        });
        wordData.push({ type: "pageBreak" });
        return;
      }
    });
    return wordData;
  };

  const handleExport = async () => {
    if (selectedRefinedUserStories.every((eachUserStory) => !eachUserStory)) {
      setNoneSelectionPopOpen(true);
      return;
    }

    try {
      const notExported = [];

      for (const [
        index,
        eachUserStory,
      ] of selectedRefinedUserStories.entries()) {
        if (eachUserStory === null || !eachUserStory) {
          continue;
        }

        const requestData = {
          ...multipleRefinedUserStories[index],
          key: multipleUserStories[index]["key"],
        };

        try {
          const exported = await exportUserStoryToJira(requestData);
        } catch (error) {
          notExported.push(multipleUserStories[index]["key"]);
        }
      }

      if (notExported.length > 0) {
        setMessage(
          `Could not export the following user stories: \n ${notExported.join(
            ", "
          )}`
        );
      } else {
        setMessage("Exported selected user stories to JIRA");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [openExportPopup, setOpenExportPopUp] = useState(false);

  const handleExportPop = () => {
    setOpenExportPopUp(true);
  };

  const buttons = [
    {
      label: "Export",
      disabled: !(
        hasSelectedUserStories &&
        Array.isArray(location.state?.userStories)
      ),
      onClick: handleExportPop,
      startIcon: (
        hasSelectedUserStories &&
          Array.isArray(location.state?.userStories)
          ? <ExportButton />
          : <ExportIcon1 />
      ),
      variant: "text",
      sx: {
        fontSize: "14px",
        textTransform: "none"
      },
    },

    {
      label: "Download",
      variant: "text",
      startIcon: <FileDownloadOutlinedIcon />,
      onClick: () => handleDownloadClick(true),
      disabled: !hasSelectedUserStories,
      sx: {
        textTransform: "none",
      },
    },
    {
      label: "Business Process Guide",
      onClick: handleMultiUseCases,
      variant: "contained",
      disabled: !hasSelectedUserStories,
      sx: {
        fontSize: "14px",
        textTransform: "none",
        float: "right",
      },
    },
  ];

  return (
    <Box sx={{ height: "100%" }}>
      <CommonAccordion
        summary={`Refined User Stories (${activeRefinedUserStories.length})`}
        details={
          <Box>
            <Box
              mb={2}
              sx={{
                overflowY: "auto",
                scrollbarWidth: "thin",
                overflowX: "hidden",
              }}
            >
              <MultiAccordian
                summaries={summaries}
                multiAccoridanDetails={refinedUserStoriesComponents}
                multiAccoridanData={multipleRefinedUserStories}
                setMultiAccordianData={setMultipleRefinedUserStories}
                selectedAccordians={selectedRefinedUserStories}
                setSelectedAccordians={setSelectedRefinedUserStories}
                isEditing={isEditing}
                setIsEditing={setIsEditing}
                editingValue={editingValue}
                setEditingValue={setEditingValue}
                loaderCheck={!!userStoryLoaderState}
              />
            </Box>
          </Box>
        }
        buttons={buttons}
        type={"output"}
        defaultExpanded={defaultMultipleRefinedUserStoriesExpanded}
        fullScreenMode={true}
      />
      <CommonDownload
        open={downloadOpen}
        onClose={handleCloseDownload}
        serviceName="Refined User Story"
        wordData={createWordData(selectedRefinedUserStories)}
        serviceResponse={[
          {
            heading: "Refined User Story",
            type: "subParagraphs",
            data: selectedRefinedUserStories?.filter((item) => item), // Filter out nulls
          },
        ]}
        documents={["docx", "pdf"]}
      />
      <SelectionErrorPopUp
        open={noneSelectionPopOpen}
        onClose={() => setNoneSelectionPopOpen(false)}
      />
      {openExportPopup && (
        // <ConfirmationDialog
        //   onClick={handleExport}
        //   setOpenExportPopUp={setOpenExportPopUp}
        //   message={message}
        //   setMessage={setMessage}
        //   text={
        //     "Exported user stories will replace and update the existing user stories"
        //   }
        //   successMessage={"Refined user stories sucessfully exported to jira"}
        // />
        <ALMConnectionPage
          issueType={"User Stories"}
          setPageCloser={setOpenExportPopUp}
          taskType="Export"
          exportData={selectedRefinedUserStories?.filter((item) => item)}
          almConfig={location.state?.almConfig}
        />
      )}
      {/* {message && <ExportSuccessfulDialog setMessage={setMessage} />} */}
      {/* <Dialog open={!!message} onClose={() => setMessage(null)}>
          <DialogTitle>Export status</DialogTitle>
          <DialogContent>{message}</DialogContent>
          <DialogActions>
            <Button onClick={() => setMessage(null)}>Close</Button>
          </DialogActions>
        </Dialog> */}
    </Box>
  );
};

export default MultipleRefinedUserStory;
